import React from "react";

export default function Advexl() {
  return (
    <div style={{ marginTop: "4rem" }} className="img">
      <div className="row justify-content-center text-center">
        <div className="col-md-10 col-lg-8">
          <div className="header-section">
      <h2 className="text-center mt-5 mb-4">
        <span className="text-danger fw-bold blink"></span> Advance Excel <span className="text-danger fw-bold blink">Training</span>
      </h2>
          </div>
        </div>
      </div>

<div class="d-flex justify-content-center my-4">
  <iframe
    width="1200"
    height="700"
    src="https://www.youtube.com/embed/0ceYr66XNOw?si=Lj6NbwUgOCaaPLXb"
    title="YouTube video player"
    frameborder="2"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen>
  </iframe>
</div>

    </div>
  );
}
